var map = {
	"./10C.png": 8142,
	"./10D.png": 2041,
	"./10H.png": 1967,
	"./10S.png": 4188,
	"./11C.png": 3358,
	"./11D.png": 6683,
	"./11H.png": 224,
	"./11S.png": 8667,
	"./12C.png": 2001,
	"./12D.png": 7198,
	"./12H.png": 278,
	"./12S.png": 7162,
	"./13C.png": 2970,
	"./13D.png": 9871,
	"./13H.png": 8965,
	"./13S.png": 8345,
	"./1C.png": 3061,
	"./1D.png": 5691,
	"./1H.png": 3448,
	"./1S.png": 6099,
	"./2C.png": 2971,
	"./2D.png": 780,
	"./2H.png": 8612,
	"./2S.png": 8032,
	"./3C.png": 5406,
	"./3D.png": 3153,
	"./3H.png": 7469,
	"./3S.png": 3577,
	"./4C.png": 7852,
	"./4D.png": 1087,
	"./4H.png": 9505,
	"./4S.png": 6097,
	"./5C.png": 561,
	"./5D.png": 6983,
	"./5H.png": 6779,
	"./5S.png": 4599,
	"./6C.png": 7580,
	"./6D.png": 6052,
	"./6H.png": 11,
	"./6S.png": 521,
	"./7C.png": 4297,
	"./7D.png": 1083,
	"./7H.png": 2409,
	"./7S.png": 9031,
	"./8C.png": 1769,
	"./8D.png": 8258,
	"./8H.png": 7805,
	"./8S.png": 6638,
	"./9C.png": 3228,
	"./9D.png": 2240,
	"./9H.png": 7043,
	"./9S.png": 4334
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1194;